import {IEventData, EEventType} from 'coreClasses/events/IEvents';
import {IAnalyticsEvent} from 'coreClasses/analytics/IAnalytics';
import Customer from 'coreClasses/customer/Customer';

import {EAnalyticsEventType} from 'brandClasses/analytics/EAnalyticsEvent';
import UserInfoModel from './common/UserInfoModel';

/**
 * Represents SignupEvent
 */
export default class SignupEvent implements IAnalyticsEvent {
	public event: EEventType;
	public user_info: any;
	public eventReady: Promise<SignupEvent>;

	/**
	 * @constructor
	 * @param {IEventData} data - data
	 * @param {EEventType} event - event type
	 */
	constructor(data: IEventData, event: EEventType) {
		const customer: Customer = data.customer;

		this.event = EAnalyticsEventType[EEventType[event]];
		this.user_info = {...new UserInfoModel(customer)};

		this.eventReady = new Promise((resolve, reject) => {
			if (!customer?.isRegistered) {
				reject();
			} else {
				resolve(this);
			}
		});
	}
}
